var _path, _g, _path2, _circle, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSaveSearch = function SvgSaveSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 49,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "save_search_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 0,
    width: 70,
    height: 48
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M14.5 0h69.333v48H14.5z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#save_search_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.549 18.07v29.96h41.82v-2.702",
    stroke: "#000",
    strokeWidth: 1.021,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M38.279 12.763h40V47.43h-40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.167 22.663v-9.334",
    stroke: "#000",
    strokeWidth: 1.021,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.33 1.356H40.128a.783.783 0 0 0-.714.437L34.79 11.57a.708.708 0 0 0 .056.707.79.79 0 0 0 .656.339h44.881a.793.793 0 0 0 .657-.339.71.71 0 0 0 .056-.707L77.88 1.793a.785.785 0 0 0-.713-.437h-8.812",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.826 13.603h17.702v-1.089H36.4c-.613 0-.948-.463-.744-1.029L38.55 3.45a1.688 1.688 0 0 1 1.485-1.03h21.628a.551.551 0 0 0 .556-.545.551.551 0 0 0-.556-.546H39.248a1.688 1.688 0 0 0-1.484 1.027l-3.68 10.218c-.205.566.13 1.03.742 1.03zm46.886 0c.591 0 .916-.462.72-1.029l-3.527-10.21a1.63 1.63 0 0 0-1.429-1.035h-8.548a.542.542 0 0 0-.537.546c0 .301.24.545.537.545h7.785a1.628 1.628 0 0 1 1.43 1.03l2.772 8.033c.196.566-.128 1.03-.72 1.03l-10.042.061v1.091l11.559-.062z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.53 48.033h17.623v-34.95l-6.685-7.07a2.712 2.712 0 0 0-3.899-.045l-7.04 7.115v34.95z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.021
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.142 42.861h6.278l1.916 5.173h-9.77l1.576-5.172z",
    fill: "#CCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.424 42.86v-7.529c0-.46.434-.835.97-.835h3.894c.536 0 .97.374.97.835v7.53",
    fill: "#F3FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.826 42.86h-1.14v-7.528c0-.13-.164-.273-.4-.273h-3.894c-.236 0-.4.143-.4.273v7.529h-1.14v-7.53c0-.77.69-1.396 1.54-1.396h3.894c.85 0 1.54.627 1.54 1.397v7.529zm1.801 5.174h-1.14v-1.461c0-.267-.274-.485-.612-.485h-7.07c-.343 0-.612.218-.612.485v1.46h-1.14v-1.46c0-.887.786-1.609 1.751-1.609h7.071c.966 0 1.752.722 1.752 1.609v1.46z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.469 45.07h-1.14v-1.46c0-.277-.17-.485-.32-.485h-5.333c-.15 0-.319.208-.319.485v1.46h-1.14v-1.46c0-.888.654-1.609 1.46-1.609h5.327c.806 0 1.46.721 1.46 1.609l.005 1.46z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.137,
    y: 11.024,
    width: 4.406,
    height: 4.405,
    rx: 0.967,
    fill: "#D9F3FE",
    stroke: "#000",
    strokeWidth: 1.021
  }), /*#__PURE__*/React.createElement("rect", {
    x: 59.137,
    y: 21.597,
    width: 4.406,
    height: 4.405,
    rx: 0.967,
    fill: "#D9F3FE",
    stroke: "#000",
    strokeWidth: 1.021
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.711 35.956v-6.597h25.687v19.266H17.711v-6.391",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.711 48.626h25.687V28.558H17.711v8.991a.451.451 0 1 0 .902 0v-8.088h23.883v18.262H18.613v-5.454a.451.451 0 1 0-.902 0v6.357z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.12 21.735h12.24c.196 0 .374.11.455.28l2.947 6.273a.457.457 0 0 1-.035.454.503.503 0 0 1-.418.217H15.802a.504.504 0 0 1-.419-.217.458.458 0 0 1-.036-.454l2.948-6.273a.5.5 0 0 1 .454-.28h5.618",
    fill: "#CCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 29.361h31.11c.29.004.568-.11.76-.312a.86.86 0 0 0 .152-.972l-2.987-6.207a.98.98 0 0 0-.888-.536H29.45c-.26 0-.469.196-.469.437 0 .242.21.437.469.437h13.197c.015 0 .028.008.034.02l2.987 6.207a.028.028 0 0 1 0 .033.032.032 0 0 1-.03.016H15.737a.034.034 0 0 1-.031-.016.031.031 0 0 1 0-.032l2.988-6.208a.036.036 0 0 1 .033-.02h5.22c.26 0 .47-.195.47-.437 0-.241-.21-.437-.47-.437h-5.223a.98.98 0 0 0-.888.536l-2.987 6.207a.859.859 0 0 0 .154.969c.192.203.47.318.76.315H14.5z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.027 46.214v-8.667c0-.531-.479-.964-1.069-.964h-4.284c-.59 0-1.069.43-1.069.964v8.669",
    fill: "#F3FBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.027 46.214v-8.667c0-.531-.479-.964-1.069-.964h-4.284c-.59 0-1.069.43-1.069.964v8.669",
    stroke: "#000",
    strokeWidth: 1.026
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.633 48.142v-1.199a1.21 1.21 0 0 0-1.208-1.209h-7.219c-.666 0-1.206.542-1.206 1.21v1.188l9.633.01z",
    fill: "#E5E5E5",
    stroke: "#000",
    strokeWidth: 1.026
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 48h97",
    stroke: "#000",
    strokeWidth: 1.021,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 83.164,
    cy: 34,
    fill: "#BCE2B5",
    r: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M93.414 34.125c0 5.592-4.533 10.125-10.125 10.125s-10.125-4.533-10.125-10.125S77.697 24 83.29 24",
    stroke: "#000",
    strokeWidth: 1.026,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m82.446 35.406 4.058-4.208a.609.609 0 0 1 .883 0 .665.665 0 0 1 0 .916l-4.941 5.125-2.87-2.977a.665.665 0 0 1 0-.916.61.61 0 0 1 .883 0l1.987 2.06z",
    fill: "#000"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91 42.272c.496 1.771 1.94 2.053 2.756 2.065 1.02.017 3.252-.357 3.135-3.825-.039-1.149-.259-2.31-.74-3.37-.314-.693-.753-1.413-1.402-1.88-.484-.348-1.07-.346-1.574-.03-.602.375-1.014.993-1.344 1.582-.554.99-.851 2.1-.959 3.21-.014.145-.025.292-.033.438-.01.184-.01.358-.01.525",
    fill: "#EEF8EC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.91 42.272c.496 1.771 1.94 2.053 2.756 2.065 1.02.017 3.252-.357 3.135-3.825-.039-1.149-.259-2.31-.74-3.37-.314-.693-.753-1.413-1.402-1.88-.484-.348-1.07-.346-1.574-.03-.602.375-1.014.993-1.344 1.582-.554.99-.851 2.1-.959 3.21-.014.145-.025.292-.033.438-.01.184-.01.358-.01.525m3.047 6.843v-3.39",
    stroke: "#1A1A1A",
    strokeWidth: 0.755,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.705 39.221c-.086-1.28-.676-1.687-.908-2.1-.331-.585.812-3.119-1.94-3.119s-1.66 2.54-1.94 3.12c-.237.492-.917.911-.917 2.36 0 2.213 1.806 2.869 2.857 2.869.755 0 1.895-.734 2.484-1.682",
    fill: "#BCE2B5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.705 39.221c-.086-1.28-.676-1.687-.908-2.1-.331-.585.812-3.119-1.94-3.119s-1.66 2.54-1.94 3.12c-.237.492-.917.911-.917 2.36 0 2.213 1.806 2.869 2.857 2.869.755 0 1.895-.734 2.484-1.682",
    stroke: "#1A1A1A",
    strokeWidth: 0.885,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.874 47.724v-5.37 5.37z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.874 47.724v-5.37",
    stroke: "#1A1A1A",
    strokeWidth: 0.885,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSaveSearch;